import { render, staticRenderFns } from "./arboviral.vue?vue&type=template&id=39a142e4&"
import script from "./arboviral.vue?vue&type=script&lang=js&"
export * from "./arboviral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports